const updateVariantInput = () => {
  const productForms = document.querySelectorAll(
    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
  );
  productForms.forEach((productForm) => {
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
};

const updateVariantStatuses = () => {
  const selectedOptionOneVariants = this.variantData.filter(
    (variant) => this.querySelector(":checked").value === variant.option1
  );
  const inputWrappers = [...this.querySelectorAll(".product-form__input")];
  inputWrappers.forEach((option, index) => {
    if (index === 0) return;
    const optionInputs = [
      ...option.querySelectorAll('input[type="radio"], option'),
    ];
    const previousOptionSelected =
      inputWrappers[index - 1].querySelector(":checked").value;
    const availableOptionInputsValue = selectedOptionOneVariants
      .filter(
        (variant) =>
          variant.available &&
          variant[`option${index}`] === previousOptionSelected
      )
      .map((variantOption) => variantOption[`option${index + 1}`]);
    this.setInputAvailability(optionInputs, availableOptionInputsValue);
  });
};

const setInputAvailability = (listOfOptions, listOfAvailableOptions) => {
  listOfOptions.forEach((input) => {
    if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
      input.innerText = input.getAttribute("value");
    } else {
      input.innerText = window.variantStrings.unavailable_with_option.replace(
        "[value]",
        input.getAttribute("value")
      );
    }
  });
};

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler);
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        if(window.innerWidth < 768) {
          this.observeButtonScroll();
        }

        this.shopTheLookScroll();
      }

      shopTheLookScroll() {
        const shopTheLookButton = document.querySelector('.product-main__look');
        const shopTheLook = document.querySelector('#shop-the-look');

        if(shopTheLook) {
          shopTheLookButton.classList.remove('hidden');
        }

        shopTheLookButton.addEventListener('click', (event) => {
          event.preventDefault();
          const href = shopTheLookButton.getAttribute('href');
          const section = document.querySelector(href);
          if (section) {
            const offset = section.offsetTop - 20;
            window.scrollTo({
              top: offset,
              behavior: 'smooth'
            });
          }
        });
      };

      observeButtonScroll() {
        const button = document.querySelector('[name="add"]');
        let config = {
          rootMargin: '0px 0px 50px 0px',
          threshold: 0
        };
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            // console.log(entry.boundingClientRect.y);
            if ( entry.boundingClientRect.y > 0 ) {
              // Button is in view
              document.getElementById('product__add-wrapper').classList.remove('sticky');
            } else {
              // Button is out of view
              document.getElementById('product__add-wrapper').classList.add('sticky');
            }
          });
        },config);

        observer.observe(button);
      };

      onSubmitHandler(event) {
        event.preventDefault();
        this.submitButton = this.querySelector('[type="submit"]');
        const spinner = this.submitButton.querySelector(
          ".loading-overlay__spinner"
        );
        if (spinner) spinner.classList.remove("hidden");
        this.submitButton.classList.add("loading");
        setTimeout(() => {
          spinner.classList.add("hidden");
          this.submitButton.classList.remove("loading");
        }, 2000);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateFormInputID();
    this.updateLowStock();
    this.updateButtons();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateButtons() {
    const klaviyoBtn = document.querySelector('.js-klaviyo-bis-trigger');

    if(this.currentVariant.available) {
      this.toggleAddButton( false, window.variantStrings.addToCart);
      if (klaviyoBtn) klaviyoBtn.classList.remove('active');
    } else {
      this.toggleAddButton( true, window.variantStrings.soldOut);
      if (klaviyoBtn) klaviyoBtn.classList.add('active');
    }
  }  

  updateLowStock() {
		const lowStockContainer = document.querySelector('.product__lowstock-container');
    const lowStockLabel = document.querySelectorAll('.low_stock_label');

    if (!lowStockContainer) return;
		lowStockContainer.classList.add('active');

    lowStockLabel.forEach((label) => {
      label.classList.toggle('active', label.dataset.value === this.currentVariant.option1);
    });
  }

  updateFormInputID() {
    const productInfo = this.closest("product-info");
    if (!productInfo) return;
    const input = productInfo.querySelector(".product-variant-id");
    input.value = this.currentVariant.id;
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const gallerySwiper = document.querySelector(
      ".product-main__gallery"
    ).swiper;
    gallerySwiper.slideTo(this.currentVariant.featured_media.position - 1);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
   
    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);
